import { AppBar, Grid, Toolbar, useTheme } from "@mui/material";
import {
	BackdropCircularProgress,
	EmptyList,
	EnhancedSnackbar,
} from "@websential/cosmic-v20";

import { FormProvider, useForm } from "react-hook-form";

import {
	EMPLOYEE_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../common/constants";
import { IGetListRequest } from "../../../models";
import { IResponse, IServerError } from "../../../models/common";
import { useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
	useNavigateToLogout,
	useRemoveQueriesOnUnmount,
} from "../../../common/Common";
import { IDropDownListResponse } from "../../../models/common/IDropDownListResponse";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { EmployeeService } from "../../../services/EmployeeService";
import { ReportsService } from "../../../services/ReportsService";
import { IAppState } from "../../../store/reducers";
import { GET_QUERY_KEY, QUERY_OPTIONS } from "../../../common/constants";
import { LookupFieldService } from "../../../services/LookupFieldService";
import { RL1ReportHeader } from "../RL1Report/RL1ReportHeader";

import { setSelectedDrawerOptionsMenu } from "../../../store/actions/drawerMenuOptionsActions";
import { RL1ReportDataGridWithColumnToggled } from "./RL1ReportDataGridWithColumnToggled";
import FileSaver from "file-saver";

export interface IRL1ReportPage { }
const RL1_REPORT_QUERY_KEY = "rl1-report-list";

const useRL1Report = (
	clientId: string,
	taxYear: number,
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [RL1_REPORT_QUERY_KEY, clientId, taxYear, params],
		queryFn: (data) => {

			return ReportsService.getRL1Report(
				clientId,
				taxYear,
				params
			);
		},
		refetchOnWindowFocus: false,
	});

export const useGetLookupFieldData = (lookupFieldId: string) =>
	useQuery({
		queryKey: [GET_QUERY_KEY.LOOKUP_FIELD_DATA_BY_ID, lookupFieldId],
		queryFn: (data) => {
			return LookupFieldService.getByIdd(lookupFieldId);
		},
		refetchOnWindowFocus: false,
	});

export const RL1ReportPageSetup: React.FC<IRL1ReportPage> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const clientIdStore = useSelector((state: IAppState) => state.client.id);
	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	const clientName = useSelector((state: IAppState) => state.client.clientName);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [rL1ListTableData, setRL1ListTableData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const {
		isLoading: isLoadingPayFrequency,
		data: rL1ReportSetupPayFrequencyList,
	} = useGetLookupFieldData("payPeriods");

	const formMethods = useForm<any>({
		// resolver: yupResolver(ValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const { handleSubmit } = formMethods;

	// const onImportFileClicked = useCallback(() => {
	// 	alert(`Import Icon Clicked!`);
	// }, []);

	// const onExcelToPdfClicked = useCallback(() => {
	// 	alert(`Excel Icon Clicked!`);
	// }, []);

	// const onApplyButtonClickedHandler = useCallback(() => {
	// 	const values = formMethods.getValues();

	// }, []);

	const onSubmit = (values: any) => {
		// let payload = {
		// 	status: values.status,
		// 	payFrequency: values.payFrequency,
		// 	payMethod: values.payMethod,
		// 	ProvinceOfEmployment: values.ProvinceOfEmployment,
		// }; //// values shoul be commented later  

	};

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "name",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const { isPending, data } = useRL1Report(
		clientIdStore,
		taxYear,
		queryParams,
		navigateToLogout
	);
	const rL1List: any | null = data;

	const [zeroEmployee, setzeroEmployee] = useState(true);

	const [submitAddRemoveColumnsHandler, setSubmitAddRemoveColumnsHandler] =
		useState(undefined);
	const [onColumnReorder, setOnColumnReorder] = useState(undefined);

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "name",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const {
		isPending: isSubmittingAddRemoveHeaderColumns,
		mutate: submitAddRemoveHeaderColumns,
	} = useMutation({
		mutationFn: ReportsService.getRL1AddRemoveHeaderColumns,
		onSuccess: (res: any | IServerError | IResponse) => {
			if (res.status === 200) {
				return queryClient.invalidateQueries({
					queryKey: [RL1_REPORT_QUERY_KEY],
				});
			} else {
				setSnackbarData({
					open: true,
					message: res.message
						? res.message
						: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: (err: any) => {
			setSnackbarData({
				open: true,
				message: err.message,
				severity: "error",
			});
		},
	});

	useEffect(() => {

		if (submitAddRemoveColumnsHandler) {
			submitAddRemoveHeaderColumns({
				clientIdStore: clientIdStore,
				columns: submitAddRemoveColumnsHandler,
				navigateToLogout: navigateToLogout,
			});
		}
	}, [submitAddRemoveColumnsHandler]);

	// const rL1ReportSetupDDlItems = useMemo(() => {
	// 	if (rL1ReportSetupPayFrequencyList) {
	// 		if (
	// 			rL1ReportSetupPayFrequencyList &&
	// 			Array.isArray(rL1ReportSetupPayFrequencyList)
	// 		) {
	// 			let resources: IDropDownListResponse[] =
	// 				rL1ReportSetupPayFrequencyList.map(
	// 					(resourceItem: IDropDownListResponse) => ({
	// 						// id: resourceItem.id,
	// 						label: resourceItem.label,
	// 						value: resourceItem.value,
	// 					})
	// 				);

	// 			resources.unshift({
	// 				label: "All",
	// 				value: "all",
	// 			});

	// 			return resources;
	// 		}
	// 		return [];
	// 	}
	// }, [rL1ReportSetupPayFrequencyList]);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	useRemoveQueriesOnUnmount(["RL1-report"]);

	const upadtedRL1ListItems = useMemo(() => {
		return (
			rL1List &&
			rL1List.items &&
			rL1List?.items.map((item: any) => ({
				...item,
			}))
		);
	}, [rL1List]);

	// const expandedLabels = ["Reports", "Compliance "];
	// const expandedRL1REportOrSetupItem = "RL1";
	// const enhanceData = (data: any[], parentLabel?: string): any[] => {
	// 	return data.map((item) => {
	// 		let isExpanded = expandedLabels.includes(item.label);
	// 		if (
	// 			parentLabel === "Compliance " &&
	// 			item.label === expandedRL1REportOrSetupItem
	// 		) {
	// 			isExpanded = true;
	// 		}
	// 		const enhancedItem = {
	// 			...item,
	// 			expanded: item.items ? isExpanded : false,
	// 			items: item.items ? enhanceData(item.items, item.label) : undefined,
	// 			path: item.label === expandedRL1REportOrSetupItem && "/reports/compliance/rl1",
	// 		};
	// 		return enhancedItem;
	// 	});
	// };

			const expandedLabels = ["Reports"];
	const enhanceData = (data: any[], ancestorChain: string[] = []): any[] => {
		return data.map((item) => {
			const currentChain = [...ancestorChain, item.label];

		
			const isComplianceUnderReports =
				item.label === "Compliance" && ancestorChain.includes("Reports");

		
			const expandedRL1REportOrSetupItem =
				item.label === "RL1" &&
				ancestorChain.includes("Reports") &&
				ancestorChain.includes("Compliance");

			const isExpanded =
				expandedLabels.includes(item.label) || 
				isComplianceUnderReports ||
				expandedRL1REportOrSetupItem;

			return {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items
					? enhanceData(item.items, currentChain)
					: undefined,
				path: expandedRL1REportOrSetupItem
					? "/reports/compliance/rl1"
					: item.path ?? undefined,
			};
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: EMPLOYEE_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));

		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
	}, [drawerMenuOptions]);

	const savePdfAsFile = (xmlData: any, filename: any) => {
		const blob = new Blob([xmlData], { type: "pdf;charset=utf-8" });
		FileSaver.saveAs(blob, filename);
	};

	const onExportButtonClick = async (selectedOption: string) => {
		try {
			setIsLoading(true);
			const response = await ReportsService.exportRL1Report(
				selectedOption,
				clientIdStore,
				taxYear,
				queryParams,
			);

			if (response) {
				if (selectedOption === "PDF") {
					if (response.status === 400) {
						setSnackbarData({
							open: true,
							message: response.data.message
								? response.data.message
								: "Something went wrong.",
							severity: "error",
						});
					} else {
						const filename = `${clientName} - RL1-Report.pdf`;
						savePdfAsFile(response, filename);
					}
				} else if (selectedOption === "XLS") {
					if (response.status === 400) {
						setSnackbarData({
							open: true,
							message: response.data.message
								? response.data.message
								: "Something went wrong.",
							severity: "error",
						});
					} else {
						const filename = `${clientName} - RL1-Report.xlsx`;
						savePdfAsFile(response, filename);
					}
				} else {
					const fileType =
						selectedOption === "XLS"
							? "application/vnd.ms-excel"
							: "text/csv;charset=utf-8;";
					const fileExtension = selectedOption === "XLS" ? "xls" : "csv";

					const blob = new Blob([response], { type: fileType });
					FileSaver.saveAs(blob, `${clientName} - RL1-Report.${fileExtension}`);
				}
			} else {
				console.error("Error: No data received from the server");
			}
		} catch (err) {

			setIsLoading(false);
		} finally {
			setIsLoading(false);
		}

	};

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_employee_list.png";

	return (
		<>
			<div
				style={{
					margin: "15px 0",
					fontSize: "1.5rem",
					fontWeight: "bold",
					fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
				}}
			>
				{"RL1 Report"}
			</div>

			<FormProvider {...formMethods}>
				<form onSubmit={handleSubmit(onSubmit)}>
					{/* <RL1ReportHeader
						rL1ReportSetupDDlItems={rL1ReportSetupDDlItems}
					/> */}
				</form>
			</FormProvider>

			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<BackdropCircularProgress
					open={
						isPending ||
						isSubmittingAddRemoveHeaderColumns
					}
					testId="RL1-report"
				/>

				<RL1ReportDataGridWithColumnToggled
					columns={
						rL1List && rL1List.headerColumns
							? rL1List.headerColumns.filter(
								(item: any) => item.field !== "id"
							)
							: []
					}
					completeHeaderColumnsList={
						rL1List && rL1List.totalHeaderColumns &&
							Object.keys(rL1List.totalHeaderColumns).length !== 0
							? rL1List.totalHeaderColumns
							: {}
						// {
						// 	name: true,
						// 	payFrequency: true,
						// 	slipType: true,
						// 	slipStatus: true
						// }
					}
					submitAddRemoveColumnsHandler={(value: any) =>
						setSubmitAddRemoveColumnsHandler(value)
					}
					onColumnReorder={(value: any) => setOnColumnReorder(value)}
					rows={
						rL1List && upadtedRL1ListItems
							? upadtedRL1ListItems
							: []
						// itams
					}
					showIndexColumn={true}
					showChecboxColumn={false}
					showSettingColumn={false}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						rL1List && rL1List.total ? rL1List.total : 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					searchFieldPlaceholder={"Search..."}
					changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
						setzeroEmployee(value)
					}
					pageTitle={"RL1 Report"}
					employeeListTableData={(data: any) => setRL1ListTableData(data)}
					onExportButtonClick={onExportButtonClick}
				/>

				{rL1List ? (
					<AppBar
						position="sticky"
						color="default"
						elevation={1}
						sx={{
							backgroundColor: "#F7F7F7",

							boxShadow: "none",
							alignItems: "center",
							zIndex: 0,
							position: "sticky",
							bottom: 0,
						}}
					></AppBar>
				) : (
					<></>
				)}
			</Grid>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
